import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useStores } from "../../../store";
import { useObserver } from "mobx-react";
import { DownloadResume } from "../resume_output";

const Resume1 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  const levelPercentage = (level) => {
    if (level === "native speaker") {
      return "w-[35%]";
    } else if (level === "highly proficient") {
      return "w-[70%]";
    } else {
      return "w-[100%]";
    }
  };

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div
        className="flex max-w-3xl w-full mx-auto bg-white shadow-lg border-l-8 border-blue-900 mt-10"
        ref={resumeRef}
      >
        <div className="bg-blue-900 text-white p-6 w-1/3 flex flex-col items-start">
          <div className="mb-6">
            <img
              src={
                ResumeStore?.resumeBuilder?.profile ??
                "https://images.unsplash.com/photo-1508341591423-4347099e1f19?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8bWVufGVufDB8fDB8fHww"
              }
              alt="Profile"
              className="rounded-full w-28 h-28 object-cover"
            />
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-medium">Contact</h2>
            <p>
              <span>
                {ResumeStore?.resumeBuilder?.personalDetails?.firstName ??
                  "RICHARD"}
              </span>{" "}
              <span>
                {ResumeStore?.resumeBuilder?.personalDetails?.lastName ??
                  "Sandez"}
              </span>
            </p>
            <p>
              <span>
                {ResumeStore?.resumeBuilder?.personalDetails?.jobTitle}
              </span>
            </p>
            <p>{ResumeStore.resumeBuilder.personalDetails?.phone}</p>
            <p>{ResumeStore.resumeBuilder.personalDetails?.email}</p>
            {ResumeStore.resumeBuilder.websites.map((item, index) => (
              <div className="flex  items-center text-sm" key={index}>
                {/* <TbPointFilled className="mr-1" /> */}
                <a
                  href={item.link}
                  target="_blank"
                  className="max-w-[90%] break-words"
                >
                  {item.link}
                </a>
              </div>
            ))}
          </div>
          <div className="mb-6">
            {ResumeStore.resumeBuilder.skills.length > 0 && (
              <h2 className="text-lg font-medium">Skills</h2>
            )}
            {ResumeStore.resumeBuilder.skills.map((item, index) => (
              <div className="flex  items-center" key={index}>
                <p className="max-w-[90%] break-words">{item.toString()}</p>
              </div>
            ))}
          </div>
          <div className="mb-6 w-full">
            <h2 className="text-lg font-medium">Languages</h2>
            {ResumeStore.resumeBuilder.languages.map((item, index) => (
              <>
                <div className="flex justify-start items-center w-full">
                  <p className="text-white text-base">{item?.language}</p>
                </div>
                <div className=" relative bg-gray-500 h-[10px] w-full rounded-full">
                  <div
                    className={`absolute rounded-full bg-yellow h-[10px] ${levelPercentage(
                      item?.level
                    )}  `}
                  ></div>
                </div>
              </>
            ))}
          </div>
        </div>
        <div className="p-6 w-2/3">
          <header className="mb-6">
            <h1 className="text-3xl font-bold text-blue-900">
              <span>
                {ResumeStore?.resumeBuilder?.personalDetails?.firstName ??
                  "RICHARD"}
              </span>{" "}
              <span>
                {ResumeStore?.resumeBuilder?.personalDetails?.lastName ??
                  "Sandez"}
              </span>
            </h1>
            <h2 className="text-xl text-gray-600">
              {ResumeStore?.resumeBuilder?.personalDetails?.jobTitle}
            </h2>
          </header>
          <div className="mb-6">
            <h2 className="text-lg font-medium text-blue-900 border-b-2 border-gray-300 pb-1">
              Profile
            </h2>
            <p>{ResumeStore.resumeBuilder?.profileSummary ?? "oremnfdsbhd"}</p>
          </div>
          <div className="mb-6">
            {ResumeStore.resumeBuilder.employementHistory.length > 0 && (
              <h2 className="text-lg font-medium text-blue-900 border-b-2 border-gray-300 pb-1">
                Work History
              </h2>
            )}
            {ResumeStore?.resumeBuilder?.employementHistory.map(
              (item, index) => (
                <div
                  key={index}
                  className="flex flex-col text-justify mt-1 ml-2 gap-1 w-full  text-sm pt-3"
                >
                  <p className="text-base font-medium text-blue-900">
                    {" "}
                    <b> {`${item?.jobTitle} `} </b> {` at  ${item?.company}`}
                  </p>
                  <p className="text-base ">{`${item?.startDate} -- ${item?.endDate}`}</p>
                  <p>{item?.city}</p>
                  <p className="w-full break-words text-justify">
                    {item?.description}
                  </p>
                </div>
              )
            )}
          </div>
          <div className="mb-6">
            {ResumeStore.resumeBuilder.education.length > 0 && (
              <h2 className="text-lg font-medium text-blue-900 border-b-2 border-gray-300 pb-1">
                Education
              </h2>
            )}
            {ResumeStore.resumeBuilder.education.map((item, index) => (
              <div
                className="flex flex-col text-justify mt-1 ml-2 gap-1 w-full text-sm pt-3"
                key={index}
              >
                <p className="text-base font-medium text-blue-900">
                  {item?.degree}
                </p>
                <p className="text-gray-600">
                  {item?.school}, {item?.city},{" "}
                  {`${item?.startDate} -- ${item?.endDate}`}
                </p>
              </div>
            ))}
            <div className="mb-4">
              <h3 className="text-base font-medium text-blue-900">
                BS in Computer Science
              </h3>
              <p className="text-gray-600">
                University of California, Berkeley, CA | 2009 - 2013
              </p>
            </div>
          </div>
          <div className="mb-6">
            {ResumeStore.resumeBuilder.courses.length > 0 && (
              <h2 className="text-lg font-medium text-blue-900 border-b-2 border-gray-300 pb-1">
                Certifications
              </h2>
            )}
            {ResumeStore.resumeBuilder.courses.map((item, index) => (
              <div
                key={index}
                className="flex flex-col text-justify mt-1 ml-2 gap-1 w-full text-sm pt-3"
              >
                <p className="text-base font-medium text-blue-900">
                  {item?.course}
                </p>
                <p className="text-gray-600">{item?.institution}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  ));
};

export default Resume1;
